module.exports = __webpack_public_path__ + "assets/tooltipJoinTeam.57aeb533.svg";